import React, { useEffect } from 'react';
import { useState } from 'react';
import { db } from "../lib/init-firebase";
import loader from "../../images/Loading_icon.gif"
import { collection, getDocs } from "firebase/firestore";
import './Experience.css'

const Experience = () => {

    const [experiences, setExperiences] = useState([])

    useEffect(() => {
        const experienceRef = collection(db, "experience");
        getDocs(experienceRef)
            .then((response) => {
                const newExperiences = response.docs.map(doc => doc.data());
                newExperiences.sort((a, b) => {
                    return a.serial - b.serial;
                });
                setExperiences(newExperiences);
            })
            .catch((error) => console.log(error.message));
    }, []);

    if (experiences.length === 0) {
        return (
            <>
                <div style={{ height: "100vh", backgroundColor: "#1A3D5D" }} className="d-flex justify-content-center align-items-center">
                    <img src={loader} width="100px" alt="" />
                </div>
            </>
        )
    }

    return (
        <div>
            <div className="container">
                <h1 className="heading text-center mb-5"><span style={{ borderBottom: '5px solid #0bc2c2' }} className="">My <span style={{ color: '#0bc2c2' }}>Experiences</span></span></h1>
                <div className="row mb-5">
                    {
                        experiences.map(experience => (
                            <div className="col-md-6">
                                <div className='bg-white text-dark p-3 h-100 rounded shadow experience-card'>
                                    <h3>{experience.position}</h3>
                                    <h5>{experience.companyName}</h5>
                                    <h5>{experience.duration}</h5>
                                    <ul>
                                        {
                                            experience.tasks.map(task => (
                                                <li>{task}</li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
};

export default Experience;